export default "__VITE_PUBLIC_ASSET__7dee2fe8__"